export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const ENTRIES_PER_PAGE = parseInt(process.env.NEXT_PUBLIC_ENTRIES_PER_PAGE || '25');
export const ENTRIES_PER_SITEMAP = parseInt(process.env.NEXT_PUBLIC_ENTRIES_PER_SITEMAP || '100');

export const DEFAULT_BACKGROUND_COLOR = '282818';

export const IFRAME_BACKGROUND_COLOR = 'FFFFFF';
